// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-events-list-request-schema',
  type: 'object',
  required: ['businessUnitNumber'],
  properties: {
    languageIso2: {
      type: 'string',
    },
    searchCriteria: {
      type: 'string',
    },
    eventTargetAudienceId: {
      type: 'integer',
    },
    eventCategoryId: {
      type: 'integer',
    },
    businessUnitNumber: {
      type: 'integer',
    },
    dateRangeFrom: {
      type: 'string',
      format: 'date-time',
    },
    dateRangeTo: {
      type: 'string',
      format: 'date-time',
    },
    eventPlace: {
      type: 'string',
    },
    eventGroupingNumber: {
      type: 'integer',
    },
    isEventPublished: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
